'use strict';
import React from 'react';
import classNames from 'classnames';
import Icon from './icon';

/**
 * Indicates a successful action on a previous page..
 * Fixed to the top of the viewport..
 * A colored SiteNotification supporting success, warning, or error priorities is supported.
 *
 * Usage:
 *
 * ```Javascript
 * <SiteNotification type="error | success | warning" />
 * ```
 *
 * @extends {React.Component}
 * @property {String} type Renders the SiteNotification message with a suitable icon and color for the defined type.
 */
class SiteNotification extends React.Component {

  /**
   * @return {String} Component Icon CSS classname.
   */
  getIconClassName (type) {
    return classNames({
      'SiteNotification-icon': true,
      [`SiteNotification-icon--${type}`]: true
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, type } = this.props;
    return (
      <div className="SiteNotification">
        <div className="SiteNotification-bar">
          <Icon className={this.getIconClassName(type)} />
          { children }
        </div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the SiteNotification component
 */
SiteNotification.propTypes = {
  type: React.PropTypes.oneOf([
    'error', 'success', 'warning'
  ]).isRequired
};

export default SiteNotification;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteNotification.jsx